module.exports = __webpack_public_path__ + "img/waiting in comfort.50fb684d.png";